/**
 * 设备识别：统一判断当前是否走移动端布局
 * - 默认按视口宽度 + UA 判断
 * - 用户可主动切换为「电脑版」，结果存 localStorage
 */
import { ref } from 'vue'

export const MOBILE_BREAKPOINT = 768
const FORCE_DESKTOP_KEY = 'forceDesktop'

export const isMobile = ref(false)

function detectMobile() {
  if (typeof window === 'undefined') return false

  try {
    if (localStorage.getItem(FORCE_DESKTOP_KEY) === '1') return false
  } catch (e) {
    // localStorage 不可用时忽略
  }

  const narrow = window.innerWidth <= MOBILE_BREAKPOINT
  const mobileUA = /Android|iPhone|iPod|iPad|HarmonyOS|Mobile|MicroMessenger/i.test(
    navigator.userAgent
  )

  return narrow || mobileUA
}

export function syncDevice() {
  isMobile.value = detectMobile()
}

/**
 * 监听视口变化，返回取消监听的函数
 */
export function watchDevice() {
  syncDevice()

  const handler = () => syncDevice()
  window.addEventListener('resize', handler)
  window.addEventListener('orientationchange', handler)

  return () => {
    window.removeEventListener('resize', handler)
    window.removeEventListener('orientationchange', handler)
  }
}

export function setForceDesktop(force) {
  try {
    if (force) {
      localStorage.setItem(FORCE_DESKTOP_KEY, '1')
    } else {
      localStorage.removeItem(FORCE_DESKTOP_KEY)
    }
  } catch (e) {
    // 忽略
  }
  syncDevice()
}

export function isForceDesktop() {
  try {
    return localStorage.getItem(FORCE_DESKTOP_KEY) === '1'
  } catch (e) {
    return false
  }
}

// 模块加载时立即初始化，避免首屏渲染时判断为空
syncDevice()
